// حل بديل يستخدم settings API مع تحسينات خاصة لـ Holiday Days
const API_URL = process.env.REACT_APP_API_URL + "settings/";

// الحصول على جميع أيام العطل من settings
export const getHolidayDaysSimpleApi = async () => {
  console.log("📡 GET Holiday Days (Simple) - Making request to:", API_URL);
  
  try {
    const response = await fetch(API_URL, {
      method: "GET",
    });
    
    console.log("📡 GET Holiday Days (Simple) - Response status:", response.status);
    
    if (response.ok) {
      const data = await response.json();
      console.log("✅ GET Holiday Days (Simple) - Success:", data);
      console.log("  Holiday days received:", data.holidayPricingDays);
      
      return {
        success: true,
        holidayPricingDays: data.holidayPricingDays || []
      };
    } else {
      const errorText = await response.text();
      console.error("❌ GET Holiday Days (Simple) - Error:", errorText);
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }
  } catch (error) {
    console.error("❌ GET Holiday Days (Simple) - Error:", error);
    throw error;
  }
};

// إضافة يوم عطلة باستخدام settings API
export const addHolidayDaySimpleApi = async (date) => {
  console.log("➕ ADD Holiday Day (Simple) - Making request for date:", date);
  
  try {
    // أولاً، احصل على الإعدادات الحالية
    const currentSettings = await getCurrentSettings();
    console.log("📋 Current settings retrieved:", currentSettings);
    
    const currentHolidays = currentSettings.holidayPricingDays || [];
    console.log("📊 Current holidays:", currentHolidays);
    
    if (currentHolidays.includes(date)) {
      console.log("⚠️ Date already exists:", date);
      return {
        success: false,
        error: "Date already exists in holiday list",
        holidayPricingDays: currentHolidays
      };
    }
    
    const newHolidays = [...currentHolidays, date];
    console.log("📊 New holidays:", newHolidays);
    
    // تحديث الإعدادات مع الـ holiday الجديد
    const updatedSettings = {
      ...currentSettings,
      holidayPricingDays: newHolidays
    };
    
    console.log("📤 Updating settings with new holiday:", updatedSettings.holidayPricingDays);
    
    const result = await updateSettings(updatedSettings);
    
    if (result.success) {
      console.log("✅ ADD Holiday Day (Simple) - Success");
      return {
        success: true,
        message: "Holiday day added successfully",
        holidayPricingDays: result.data.holidayPricingDays || newHolidays
      };
    } else {
      throw new Error(result.error || "Failed to update settings");
    }
    
  } catch (error) {
    console.error("❌ ADD Holiday Day (Simple) - Error:", error);
    throw error;
  }
};

// حذف يوم عطلة باستخدام settings API
export const removeHolidayDaySimpleApi = async (date) => {
  console.log("🗑️ REMOVE Holiday Day (Simple) - Making request for date:", date);
  
  try {
    // أولاً، احصل على الإعدادات الحالية
    const currentSettings = await getCurrentSettings();
    console.log("📋 Current settings retrieved:", currentSettings);
    
    const currentHolidays = currentSettings.holidayPricingDays || [];
    console.log("📊 Current holidays:", currentHolidays);
    
    if (!currentHolidays.includes(date)) {
      console.log("⚠️ Date not found:", date);
      return {
        success: false,
        error: "Date not found in holiday list",
        holidayPricingDays: currentHolidays
      };
    }
    
    const newHolidays = currentHolidays.filter(d => d !== date);
    console.log("📊 New holidays:", newHolidays);
    
    // تحديث الإعدادات بدون الـ holiday المحذوف
    const updatedSettings = {
      ...currentSettings,
      holidayPricingDays: newHolidays
    };
    
    console.log("📤 Updating settings after removal:", updatedSettings.holidayPricingDays);
    
    const result = await updateSettings(updatedSettings);
    
    if (result.success) {
      console.log("✅ REMOVE Holiday Day (Simple) - Success");
      return {
        success: true,
        message: "Holiday day removed successfully",
        holidayPricingDays: result.data.holidayPricingDays || newHolidays
      };
    } else {
      throw new Error(result.error || "Failed to update settings");
    }
    
  } catch (error) {
    console.error("❌ REMOVE Holiday Day (Simple) - Error:", error);
    throw error;
  }
};

// دالة مساعدة للحصول على الإعدادات الحالية
const getCurrentSettings = async () => {
  console.log("📋 Getting current settings...");
  
  const response = await fetch(API_URL, {
    method: "GET",
  });
  
  if (response.ok) {
    const data = await response.json();
    console.log("✅ Current settings retrieved successfully");
    return data;
  } else {
    const errorText = await response.text();
    console.error("❌ Failed to get current settings:", errorText);
    throw new Error(`Failed to get settings: ${response.status} - ${errorText}`);
  }
};

// دالة مساعدة لتحديث الإعدادات
const updateSettings = async (settings) => {
  console.log("🔄 Updating settings...");
  
  const token = localStorage.getItem("token");
  console.log("🔑 Token:", token ? "Token exists" : "No token");
  
  const response = await fetch(API_URL, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(settings)
  });
  
  console.log("📡 Update settings - Response status:", response.status);
  
  if (response.ok) {
    const data = await response.json();
    console.log("✅ Settings updated successfully");
    console.log("🔍 Updated holidayPricingDays:", data.holidayPricingDays);
    
    return {
      success: true,
      data: data
    };
  } else {
    const errorText = await response.text();
    console.error("❌ Failed to update settings:", errorText);
    
    return {
      success: false,
      error: `Update failed: ${response.status} - ${errorText}`
    };
  }
};